import React from "react";
import R14, {
  TextInputField,
  StyleSheet,
  Button,
  Form,
  Text,
  View, 
  AsyncStorage,
} from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import BottomPaySection from "../components/BottomPaySection";
import CommonValidators from "../utils/CommonValidators";
import { PAGE_PATH, MSG_TYPE, BILL_STATUS, CURRENCY, MESSAGE_TYPE } from "../constant/app.data.constant";
import BillerDetails from "../components/BillerDetails";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import CommonUtility from "../utils/CommonUtility";
import { CommonString } from "../constant/appCommonText";
import PopupModalComponent from "../components/PopupModalComponent";
import ChatboxInputField from "../components/ChatboxInputField";
import RSAencryption from "../utils/RSAencryption";

export default R14.connect(
  class PaymentScreen extends React.Component {
    constructor(props) {
      super(props);
      this.form = null;
      this.state = {
        isSuccess: false,
        isLoading: false,
        cmnts: null,
        amt: null,
        amtPayable: parseFloat(props.billData.amountDue),
        addCardVisible: false,
        cardValue: "",
        isDebit: true,
        cvvNumber: null,
        debitCardList: [],
        creditCardList: [],
        billData: this.props.billData,
        isCardSelected: true,
        defaultSelectedItem: [],
        IsAllowOtherPay: false,
        testPayConfirmation: false
      }
      this.cardToken = null;
      this.initialFormData = {
        currencyCode: { label: "USD", value: "1" },
      };
      this.cardIconPath = null;
      // Create the child instance using react createRef
      this.child = React.createRef();
    }

    async componentDidMount() {
      let { payType } = this.props;
      if (payType === PAGE_PATH.PAYPART) {
        this.setState({
          isLoading: true,
        });
      }

      this.form = this.props.app.ui.form("payOpt");
      let debitCardList = [];
      let creditCardList = [];
      let extOpt = { cvvNumber: "", isChecked: "" };
      if (this.props.cardDisplayList) {
        this.props.cardDisplayList.forEach((item) => {
          if (item.paymentType === "Debit Card") {
            debitCardList.push({ ...item, ...extOpt });
          } else {
            creditCardList.push({ ...item, ...extOpt });
          }
        });
        this.setState({ debitCardList: debitCardList, creditCardList: creditCardList });
      }
      let defaultSelectedItem = this.props.cardDisplayList.filter((el) => el.isSetDefault === true);
      if (!!defaultSelectedItem.length > 0) {
        this.setState({ defaultSelectedItem: defaultSelectedItem });
        this.cardToken = defaultSelectedItem[0].token ? defaultSelectedItem[0].token : null;
      } else {
        this.cardToken = null;
      }
    }
  
    onSubmit = async (form) => { 
      return false;
    };

  max10WithDecimal = async (value) => {
    let isValid = /^\+?(\d*[1-9]\d*\.?|\d*\.\d*[0-9]\d*)$/gi.test(value.trim());
    if (isValid && (value < 0.5 || value.length > 9)) {
      isValid = false;
    }
    return isValid ? true : false;
  };

    onPaymentDone = async (transactionId) => {
      let { amtPayable } = this.state;
      const { billData, payType, msgList } = this.props;
      const { comments, amount } = this.form.values;

      amtPayable = parseFloat(amtPayable.toFixed(2));
      
      this.setState({
        testPayConfirmation: false 
      })

      if (payType === PAGE_PATH.PAYPART) {
        if (!(!!amount && +amount && amount > 0.1)) {
          return this.form.elmts.amount.setError(CommonString.EnterAmountRequired);
        } else if (!this.max10WithDecimal(`${amount}`)) {
          return this.form.elmts.amount.setError(CommonString.MIN1MAX10Digit);
        };
      }
      if (!!comments  && comments.length >= 126) {
        this.form.elmts.comments.setError(CommonString.ContentExceed125);
        return false;
      }
      let clonedBill = { ...billData }; /// Cloning object
      clonedBill.additionalInformation = (transactionId && transactionId.paymentMode ? `${transactionId.paymentMode}` : ``) + (!!comments ? `-${comments}` : "");
      let lastPaidAmount = amount;

      this.setState({
        isLoading: true,
      });

      if (payType === PAGE_PATH.PAYPART) {
        if (lastPaidAmount > amtPayable) {
          this.form.elmts.amount.setError("Amount should not be greater than the Amount Payable.");
          this.setState({ isLoading: false });
          return false;
        }
        clonedBill.amount = lastPaidAmount;
      } else {
        lastPaidAmount = amtPayable;
        clonedBill.amount = amtPayable;
      }
      
      if (!!transactionId.success) {
        clonedBill.transactionId = transactionId.transactionId;
        let lastLeaf = {
          ...msgList[msgList.length - 1],
          billData: clonedBill,
          attachments: !!this.fileAttach ? [this.fileAttach] : null,
          messageType: payType === PAGE_PATH.PAYPART ? MSG_TYPE.PAY_PART : MSG_TYPE.PAY_ALL
        };
        this.props.app.dm.userSession.setState({isLoading: true});
        let payload = await this.props.app.dm.billDetails.getPaymentPayload(lastLeaf, transactionId.paymentMode, false, payType);

        try {
          let dbpayload = {};
          if(payType === PAGE_PATH.PAYFULL){
            dbpayload = await this.props.app.dm.billDetails.fullPaidBill(payload);
          } else {
            dbpayload = await this.props.app.dm.billDetails.partPaidBill(payload);
          }
          if (dbpayload && dbpayload.success) {
            dbpayload = dbpayload.billDetail;
            const { compiledMsgList, filterBills } = this.props.app.dm.dashboard.state;
            if (!!compiledMsgList.length && !!filterBills.length) {
              let ind = compiledMsgList.findIndex((el) => el.uid === clonedBill.uid);
              compiledMsgList[ind].billStatus = dbpayload.billStatus;
              compiledMsgList[ind].amountDue = dbpayload.amountDue;
              compiledMsgList[ind].amountPaid = dbpayload.amountPaid;
              compiledMsgList[ind].bookmark = dbpayload.bookmark;
              compiledMsgList[ind].lastPaidAmount = dbpayload.lastPaidAmount;
              compiledMsgList[ind].paymentMode = dbpayload.paymentMode;
              compiledMsgList[ind].paymentStatus = dbpayload.paymentStatus;
              compiledMsgList[ind].rtpMessageType = dbpayload.rtpMessageType;
              compiledMsgList[ind].isFailedPayment = dbpayload.isFailedPayment;
              compiledMsgList[ind].paymentType = dbpayload.paymentType;
              let fndx = filterBills.findIndex((el) => el.uid === clonedBill.uid);
              filterBills[fndx].billStatus = dbpayload.billStatus;
              filterBills[fndx].amountDue = dbpayload.amountDue;
              filterBills[fndx].amountPaid = dbpayload.amountPaid;
              filterBills[fndx].bookmark = dbpayload.bookmark;
              filterBills[fndx].lastPaidAmount = dbpayload.lastPaidAmount;
              filterBills[fndx].paymentMode = dbpayload.paymentMode;
              filterBills[fndx].paymentStatus = dbpayload.paymentStatus;
              filterBills[fndx].rtpMessageType = dbpayload.rtpMessageType;
              filterBills[fndx].isFailedPayment = dbpayload.isFailedPayment;
              filterBills[fndx].paymentType = dbpayload.paymentType;

              await this.props.app.dm.dashboard.updateBillCount(compiledMsgList, filterBills);
            }
            this.props.app.dm.userSession.setState({isLoading: false});
            let newBill = {
              ...billData,
              ...dbpayload,
              paidAmount: parseFloat(billData.paidAmount) + parseFloat(amount || amtPayable),
            };
            this.props.app.dm.billDetails.setState({
              billDetails: newBill
            });
            setTimeout(() => {
              let threadId = billData.threadId; //.replaceAll("#", ">>");
              this.props.app.nav.to("billReceiptRoute", { threadId: threadId });
            }, 100);
          } else {
            this.props.app.dm.userSession.setState({isLoading: false});
            this.props.app.dm.commonDomain.showToastr("error", CommonString.MessageFail);
          }
        } catch (err) {
          this.setState({ isLoading: false });
          console.log("Error: ", err);
          this.props.app.dm.userSession.setState({isLoading: false});
          this.props.app.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        } finally {
          this.props.app.dm.userSession.setState({isLoading: false});
          this.setState({ isLoading: false });
          return false;
        }
      } else {
        clonedBill.transactionId = transactionId.transactionId;
        {
          let dbpayload = {
            billStatus: "Failed",
            paymentStatus: "Failed",
            uid: billData.uid,
            isFailedPayment: true,
            failDate: new Date().toUTCString(),
            lastPaidAmount: lastPaidAmount,
            failReason: transactionId.error ? transactionId.error : "Transaction Failed.",
          };
          await this.props.app.dm.dashboard.updateBill({ ...dbpayload });
          const { compiledMsgList, filterBills } = this.props.app.dm.dashboard.state;
          if (!!compiledMsgList.length && !!filterBills.length) {
            let ind = compiledMsgList.findIndex((el) => el.uid === clonedBill.uid);
            compiledMsgList[ind].billStatus = dbpayload.billStatus;
            compiledMsgList[ind].failReason = dbpayload.failReason;
            compiledMsgList[ind].paymentStatus = dbpayload.paymentStatus;
            let fndx = filterBills.findIndex((el) => el.uid === clonedBill.uid);
            filterBills[fndx].billStatus = dbpayload.billStatus;
            filterBills[fndx].failReason = dbpayload.failReason;
            filterBills[fndx].paymentStatus = dbpayload.paymentStatus;

            await this.props.app.dm.dashboard.updateBillCount(compiledMsgList, filterBills);
          }

          let newBill = {
            ...billData,
            billStatus: dbpayload.billStatus,
            paymentStatus: dbpayload.paymentStatus,
            isFailedPayment: dbpayload.isFailedPayment,
            failDate: dbpayload.failDate,
            failReason: dbpayload.failReason,
          };
          this.props.app.dm.billDetails.setState({
            billDetails: newBill
          });
          this.setState({ billData: newBill, isLoading: false });

          if (!!!transactionId.isCancelByUser) {
            this.props.app.dm.billDetails.setState({
              isShowErrorMsg: true
            })
          }
          else
            this.setState({
              errorMessage: `${transactionId.error ? transactionId.error : "Transaction Failed."}`
            });
        }
      }
    };

    readText = (val) => {
      if ((!val && !!this.form) || val.length <= 125) {
        this.form.elmts.comments.setError(null);
      } else if (val.length > 125) {
        this.form.elmts.comments.setError(CommonString.ContentExceed125);
      }
    };

    onAttachment = async (val) => {
      this.fileAttach = val;
    };

    amountText = async (val) => {
      let amtText = val;
      if (!!val) {
        amtText = amtText.replace(/[^\d.]/g, "").substring(0, 10);
        amtText = amtText.indexOf('.') > -1 && amtText.split('.')[1].length > 2 > 0 ? parseFloat(amtText).toFixed(2) : amtText;
        this.form.elmts.amount.setValue(amtText);
      }
      let isValid = /^\+?(\d*[1-9]\d*\.?|\d*\.\d*[0-9]\d*)$/gi.test(amtText);

      if (isValid && (amtText < 0.5 || amtText.length > 9)) {
        isValid = false;
      }
      const { amtPayable } = this.state;
      const { payType } = this.props;

      this.setState({ isLoading: true });
      if (isValid) {
        this.form.elmts.amount.setValue(amtText);
        this.form.elmts.amount.setError(null);
        if (payType === PAGE_PATH.PAYPART) {
          if (parseFloat(amtText) === parseFloat("0.00")) {
            this.form.elmts.amount.setError(CommonString.InvalidAmount);
            return false;
          }
          else if (parseFloat(amtText) > parseFloat(amtPayable)) {
            this.form.elmts.amount.setError(CommonString.AmountPayableExceedError);
            return false;
          } else {
            if (!!this.child && !!this.child.current && !!this.child.current.wrappedInstance)
              await this.child.current.wrappedInstance.updateOnPartPayment(payType, amtText, amtPayable);
            this.setState({
              isLoading: false,
            });
          }
        }
      } else if (amtText === "") {
        this.form.elmts.amount.setError(null);
      } else {
        this.form.elmts.amount.setError("Enter valid amount");
      }
    }

    toggelBookmark = async (bkmrk) => {
      const { billData } = this.props;
      const { compiledMsgList, filterBills } = this.props.app.dm.dashboard.state;
      if (!!compiledMsgList.length && !!filterBills.length) {
        let ind = compiledMsgList.findIndex((el) => el.uid === billData.uid);
        compiledMsgList[ind].bookmark = bkmrk;
        this.setState({ billData: { ...billData, ...compiledMsgList[ind] } });
        let findx = filterBills.findIndex((el) => el.uid === billData.uid);
        filterBills[findx].bookmark = bkmrk;
        await this.props.app.dm.dashboard.setState({ compiledMsgList, filterBills });
      }
    };

    onCancel = async() => {
      this.setState({ testPayConfirmation: false })
      return false;
    }

    onPay = async () => {
      try {
        let { comments = "", amount = "0.00" } = this.form.values;
        let { amtPayable } = this.state;
        const { billData, payType, msgList } = this.props;
        amtPayable = parseFloat(amtPayable.toFixed(2));
        if (payType === PAGE_PATH.PAYPART) {
          if (!(!!amount && +amount && amount > 0.1)) {
            return this.form.elmts.amount.setError(CommonString.EnterAmountRequired);
          } else if (!this.max10WithDecimal(`${amount}`)) {
            return this.form.elmts.amount.setError(CommonString.MIN1MAX10Digit);
          };
        }
        if (!!comments && comments.length >= 126) {
          this.form.elmts.comments.setError(CommonString.ContentExceed125);
          return false;
        }
        let clonedBill = { ...billData }; /// Cloning object
        clonedBill.additionalInformation = (!!comments ? comments : "");
        let lastPaidAmount = amount;

        this.setState({
          isLoading: true,
          testPayConfirmation: false
        });

        if (payType === PAGE_PATH.PAYPART) {
          if (lastPaidAmount > amtPayable) {
            this.form.elmts.amount.setError("Amount should not be greater than the Amount Payable.");
            this.setState({ isLoading: false });
            return false;
          }
          clonedBill.amount = lastPaidAmount;
        } else {
          lastPaidAmount = amtPayable;
          clonedBill.amount = amtPayable;
        }

        let lastLeaf = {
          ...msgList[msgList.length - 1],
          billData: clonedBill,
          attachments: !!this.fileAttach ? [this.fileAttach] : null,
          messageType: payType === PAGE_PATH.PAYPART ? MSG_TYPE.PAY_PART : MSG_TYPE.PAY_ALL
        };
        this.props.app.dm.userSession.setState({ isLoading: true });
        let payload = await this.props.app.dm.billDetails.getPaymentPayload(lastLeaf, null, false, payType);

        const res = await this.props.app.dm.billDetails.stripePayment(payload);
        if (!!res && !!res.success) {
          this.props.app.dm.userSession.setState({ isLoading: false });
          if (!!res.message) {
            AsyncStorage.setItem(CommonString.LOCAL_STORAGE_BILLRECEIPTS, RSAencryption.encryptDataByBTOA(`${res.data}`));
            this.props.app.nav.to("checkout", { data: RSAencryption.encryptDataByBTOA(`${this.props.billData.uid}`) });
            return false;
          }
          else {
            this.props.app.dm.userSession.setState({ isLoading: false });
            this.props.app.dm.commonDomain.showToastr("error", res.message || CommonString.SomethingWentWrong);
            return false;
          }
        }
        else {
          this.props.app.dm.userSession.setState({ isLoading: false });
          this.props.app.dm.commonDomain.showToastr("error", res.message || CommonString.SomethingWentWrong);
          this.props.app.dm.billDetails.setState({ isShowErrorMsg: true });
          return false;
        }
      } catch (error) {
        this.props.app.dm.userSession.setState({ isLoading: false });
        this.props.app.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
      }
    }

    confrimPayment = () => {
      let { comments = "", amount = "0.00" } = this.form.values;
      if (!!comments && comments.length > 125) {
        this.form.elmts.comments.setError(CommonString.ContentExceed125);
        return false;
      }
      let amtText = this.state.amtPayable;
      if (this.props.payType === PAGE_PATH.PAYPART)
        amtText = parseFloat(amount);

      let isValid = /^\+?(\d*[1-9]\d*\.?|\d*\.\d*[0-9]\d*)$/gi.test(amtText);

      if (isValid && (amtText < 0.5 || amtText.toString().length > 9)) {
        isValid = false;
      }

      if (!!!isValid) {
        this.setState({ isLoading: true });
        this.props.app.dm.commonDomain.showToastr("error", CommonString.InvalidAmount);
      }
      else
        this.setState({ testPayConfirmation: true });
      return false;
    }

    render() {
      const { payType, isAllowPayment } = this.props;
      const { billData, testPayConfirmation, isLoading, amtPayable } = this.state;
      return (
        <>
          <PopupModalComponent
            visibility={!!testPayConfirmation}
            bodyWrapper={[commonStyles.smallModalBodyWrapper, styles.modalBodyWrapper]}
            messageType={MESSAGE_TYPE.info}
            headingIcon={true}
            heading={"Payment Confirmation"}
            modalContent={[commonStyles.marginTop10, commonStyles.marginBottom10]}
            bodyContent={`Please click continue to select payment options.`}
            okLabel={"Continue"}
            handleOk={() => this.onPay()}
            modalPopupOkBtn={[commonStyles.width85]}
            closeLabel={"Cancel"}
            handleClose={this.onCancel}
            modalPopupCancelBtn={[commonStyles.width85]}
          />
            <View style={[styles.container, styles.position]}>
              <Form
                name="payOpt"
                style={[commonStyles.paddingLeft0, commonStyles.paddingRight0, commonStyles.paddingTop0, commonStyles.flexGrow0]}
                backgroundColor="#fff"
                onSubmit={this.onSubmit}
                validateBeforeSubmit={true}
                initialValues={this.initialFormData}
                validators={CommonValidators.getFormValidator()}>
                <BillerDetails customStyles={commonStyles.padding0} billData={billData} payType={payType} onBkmkToggle={this.toggelBookmark} customFlexDirection={styles.customFlexDirection} />
                <View
                  style={[
                    commonStyles.flex1,
                    commonStyles.justifyContentSpaceBetween,
                    commonStyles.alignItemsCenter,
                    styles.customPaddingTopBottom5,
                    commonStyles.borderTopBottom,
                    commonStyles.flexDirectionRow
                  ]}>
                  <View>
                    <Text style={[commonFontStyles.workSans, commonStyles.heading6, commonStyles.fontWeight600]}>Amount Payable</Text>
                  </View>
                  <View style={[commonStyles.minWidth110]}>
                    <Text style={[commonFontStyles.workSans, commonStyles.heading5, commonStyles.fontWeight600, commonStyles.amountPayable]}>
                      {CURRENCY[billData.currency]}{CommonUtility.formatAmount(amtPayable.toFixed(2), this.props.app)}
                    </Text>
                  </View>
                </View>

                <View style={[styles.bottomSectionOuter]}>
                  <View style={styles.bottomPaySection}>
                    <BottomPaySection
                      threadId={billData.threadId}
                      activePage={payType}
                      isDisabled={BILL_STATUS[billData.billStatus]}
                      extraOpt={billData.rtpMessageType}
                      billerDetails={this.props.billData.biller}
                      billDetails = {this.props.billData}
                      customBtnStyles={commonStyles.customPayBtnStyles}
                      customPaySectionContainer={commonStyles.justifyContentFlexStart}
                      customActiveBtn={commonStyles.customActiveBtn}
                      customActiveBtnText={commonStyles.customActiveBtnText}
                      customInActiveBtn={commonStyles.customInActiveBtn}
                      customInActiveBtnText={commonStyles.customInActiveBtnText}
                    />
                  </View>
                </View>

                <View style={[commonStyles.marginBottom16, commonStyles.marginTop5]}>
                  {payType === PAGE_PATH.PAYPART ? (
                    <View style={[commonStyles.marginBottom30]}>
                      <TextInputField
                        labelTextStyle={[commonStyles.labelText, commonFontStyles.workSans]}
                        labelStyle={[commonStyles.formLabelStyle, customCommonStyles.inputLableStyle]}
                        name="amount"
                        label={CommonString.EnterAmountLabel + "*"}
                        required={CommonString.EnterAmountRequired}
                        validator="max10WithDecimal"
                        onChangeText={async (val) => await this.amountText(val)}
                        valueParser={(val) => parseFloat(val)}
                        style={[commonStyles.marB0, customCommonStyles.inputHeight, commonFontStyles.workSans]}
                        helperTextStyle={[styles.customHelperTextStyle, customCommonStyles.helperTextStylecustom, commonStyles.helperTextFontStyle, commonFontStyles.workSans, commonStyles.left0]}
                      />
                    </View>
                  ) : null}
                  <ChatboxInputField
                    onValueChange={this.onAttachment}
                    onChangeText={this.readText}
                    commentsProps={{
                      name: "comments",
                      required: "Enter the comments",
                      label: "Comments",
                    }}
                    multiline={true}
                    validator="cmtsVali"
                    textBoxStyle={[commonStyles.smallTextBoxStyle]}
                    attachmentBoxStyle={[commonStyles.smallAttachmentBoxStyle]}
                    sendBtnBoxStyle={[commonStyles.smallSendBtnBoxStyle]}
                    /> 
                </View>
                <View style={[commonStyles.flex1, commonStyles.alignItemsEnd, commonStyles.marginTop20]}>
                {!!isAllowPayment && (!!this.props.billData.biller && (!!this.props.billData.biller.isPaymentsFull || this.props.billData.biller.isPaymentsPartial)) ?
                  <>
                    <View style={[commonStyles.marginBottom16, commonStyles.displayNone]}>
                      <Text style={[commonFontStyles.workSans, commonStyles.heading6, commonStyles.fontWeight600, commonStyles.darkGrayColor]}>
                        Select Payment Option
                      </Text>
                    </View>

                    <Button
                      title="Pay Now"
                      key="btnPayNow"
                      style={[commonStyles.flexBasis50, customCommonStyles.noBoxShadow, commonStyles.blueButton, commonStyles.btnHeight24, commonStyles.btnWidth108, styles.maxHeight24, !!isLoading ? commonStyles.disabledBtn : null]}
                      titleTextStyle={[commonFontStyles.workSans, commonStyles.exSmallHeading, commonStyles.fontWeight500, commonStyles.whiteColor, !!isLoading ? commonStyles.disabledBtnText : null]}
                      onPress={() => !!isLoading ? null : this.confrimPayment()}
                      isLoading={isLoading}
                    />
                  </> : null}
                </View>
              </Form>

            </View>
        </>
      );
    }
  }
);

const styles = StyleSheet.create({
  position: {
    position: "relative",
    flexGrow: 1,
  },
  container: {
    backgroundColor: "#fff",
    paddingTop: 16,
    paddingRight: 15,
    paddingBottom: 0,
    paddingLeft: 15,
    position: "relative",
    ...StyleSheet.margin(0, 16, 16, 16),
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          borderWidth: 0,
          paddingTop: 16,
          paddingRight: 16,
          paddingBottom: 30,
          paddingLeft: 16,
          margin: 0,
        };
    },
  },
  cardHeadingText: {
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    flexDirection: "column",
    position: "relative",
  },
  cardBoxBorder: {
    display: "block",
    width: "100%",
    position: "absolute",
    bottom: 0,
    height: 2,
    backgroundColor: "#0C7DA6",
  },
  card: {
    minHeight: 65,
  },
  cardDetail: {},
  cardIcon: {},
  cardIconImage: {
    width: 38,
    height: 38,
    display: "block",
    backgroundSize: "contain",
  },
  cvv: {
    width: 46,
    paddingTop: 0,
    paddingRight: 5,
    paddingBottom: 4,
    paddingLeft: 5,
    height: 26,
    margin: 0,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#dadada",
    textAlign: "center",
    fontSize: "12px",
    marginLeft: 7,
  },
  bottomSectionOuter: {
    bottom: 0,
    width: "100%",
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    left: 0,
    zIndex: 101,
    marginTop: 0,
    marginBottom: 0,
  },
  bottomPaySection: {
    border: 0,
  },
  noRecords: {
    color: "red",
    position: "static",
    marginTop: 15,
  },
  customFlexDirection: {
    flexDirection: "row",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          flexDirection: "column",
        };
    },
  },
  customPaddingTopBottom5: {
    paddingTop: 10,
    paddingBottom: 10,
    screen: ({ width, height }) => {
      if (width === 1366 && height === 657)
        return {
          paddingTop: 0,
          paddingBottom: 0,
        };
    },
  },
  maxHeight24: {
    maxHeight: 24
  },
});
